export const formatCurrencyNumber = (amount) => {
    if (!amount){
        return '0';
    }
    const params = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };

    return amount.toLocaleString('pt-BR', params);
}

export const replaceAll = (str, search, replacement) => str.split(search).join(replacement);


// WEBPACK FOOTER //
// ./src/Common/format.js